import type { IconData } from '@stacksjs/iconify-core'

export const compassNavigator: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M35.835 35.835c-4.253 4.253-21.681 7.928-29.728 9.436a2.865 2.865 0 0 1-3.361-3.375c1.543-8.074 5.287-25.598 9.42-29.731s21.657-7.877 29.73-9.42a2.865 2.865 0 0 1 3.375 3.362c-1.507 8.046-5.182 25.474-9.436 29.728\"/><path d=\"M24 17a7 7 0 1 0 0 14a7 7 0 0 0 0-14\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default compassNavigator
